var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":true,"close-on-click-modal":false,"show-close":true,"before-close":_vm.beforeClose,"modal-append-to-body":false,"width":"750px","title":_vm.$t('Audiences_SegmentEvaluations_CalculateSize_DialogTitle', {
      date: _vm.dateCreated
    }),"center":""}},[_c('segment-counts-top-bar',{attrs:{"metrics":_vm.taskData.task.count,"type":_vm.taskData.task.scope,"columns":3}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23cd47e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/audiences/components/CalculateSizePreviewDialog.vue
// module id = null
// module chunks = 